import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, inject, ChangeDetectionStrategy, signal } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import {PersonLogin, RoleName} from '../person/person-login';
import {PersonLoginService} from '../services/person-login-service';
import {ProductService} from '../services/product-service';
import {StringUtils} from '../utils/string-utils';
import {ProductHeader} from './product-header';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

import { FormsModule } from '@angular/forms';

@Component({
    selector: 'product-header',
    templateUrl: './product-header.component.html',
    styleUrls: ['./product-header.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FormsModule, MatProgressSpinner, RouterLink]
})
export class ProductHeaderComponent implements OnInit {
  private readonly personLoginService = inject(PersonLoginService);
  private readonly productService = inject(ProductService);
  private readonly router = inject(Router);


  public personLogin!: PersonLogin;
  readonly searchResults = signal<ProductHeader[]>(undefined!);
  public searchTerm!: string;
  readonly isBusy = signal<boolean>(undefined!);
  readonly errorMessage = signal<string>(undefined!);
  readonly searchComplete = signal<boolean>(undefined!);

  public newProduct(): void {
    this.router.navigate(['product/new']);
  }

  public search(): void {
    if (!this.isBusy() && this.searchTerm && this.searchTerm.length >= 3) {
      this.clearStatus();
      this.productService.search(this.searchTerm).subscribe(results => {
        this.searchResults.set(results);
        this.isBusy.set(false);
        this.searchComplete.set(true);
      }, error => this.handleError(error));
    }
  }

  public handleKeyUp(keyEvent: any): void {
    if (keyEvent.keyCode === 13) {
      this.search();
    }
  }

  private clearStatus(): void {
    this.isBusy.set(true);
    this.errorMessage.set(undefined!);
    this.searchComplete.set(false);
    this.searchResults.set(undefined!);
  }

  private handleError(error: HttpErrorResponse): void {
    this.isBusy.set(false);
    this.errorMessage.set(StringUtils.getErrorMessage(error));
  }

  ngOnInit(): void {
    if (!this.personLoginService.hasRole(RoleName.IECIT)) {
      this.router.navigate(['main']);
    }
    this.personLogin = this.personLoginService.getCachedLogin()!;
  }

}
